module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-check-61091340.svg";